// extracted by mini-css-extract-plugin
export var logo = "_lz-2";
export var logoWrapper = "_lz-1";
export var strip = "_lz-0";